import { InsuranceType, TherapyTarget } from 'domains/signup/data/types';
import type { Option } from 'components/Forms';

interface TherapyTargetOption extends Option {
  value: TherapyTarget;
}

export const therapyTargetOptions: TherapyTargetOption[] = [
  { label: 'My Child', value: 'child' },
  { label: 'Myself', value: 'adult' },
  { label: 'Another Adult', value: 'another-adult' },
];

interface InsuranceTypeOption extends Option {
  value: InsuranceType;
}

export const insuranceTypeOptions: InsuranceTypeOption[] = [
  { label: `I get insurance from work (or my spouse's work)`, value: 'work' },
  { label: `I purchase insurance myself`, value: 'private' },
  { label: 'Medicaid', value: 'medicaid' },
  { label: 'Medicare', value: 'medicare' },
  { label: `I'm not sure`, value: 'other' },
];
